import * as React from 'react';

import { CloseIcon, SearchIcon } from 'shared/newComponents/icons';
import { IconSize } from 'shared/entities/components/Icon';
import { ComponentType } from 'shared/entities/components/Component';
import {
  renderTranslationString,
  TranslationString,
  useTypedTranslation
} from 'shared/entities/localization';

import './SelectorPopupSearch.modules.scss';

type Props = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: TranslationString | string;
  autoFocus?: boolean;
  onEnter?: () => void;
  className?: string;
};

const SelectorPopupSearch: React.FC<Props> = ({
  value,
  onChange,
  placeholder,
  autoFocus = true,
  onEnter,
  className
}: Props) => {
  const { t } = useTypedTranslation();
  const handleChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange(event.target.value);
    },
    [onChange]
  );

  const handleClear = React.useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation();
      onChange('');
    },
    [onChange]
  );

  const handleKeyDown = React.useCallback(
    (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === 'Enter' && onEnter) {
        event.preventDefault();
        onEnter();
      }
    },
    [onEnter]
  );

  return (
    <div styleName="selector-popup-search" className={className}>
      <SearchIcon
        iconSize={IconSize.XM}
        styleName="selector-popup-search__icon"
      />
      <input
        styleName="selector-popup-search__input"
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={
          placeholder
            ? renderTranslationString(placeholder, t)
            : renderTranslationString(
                (t) => t('Selector.search', { ns: 'newComponents' }),
                t
              )
        }
        autoFocus={autoFocus}
      />
      {!!value && (
        <CloseIcon
          iconSize={IconSize.S}
          styleName="selector-popup-search__clear"
          action={{
            type: ComponentType.svg,
            onClick: handleClear
          }}
        />
      )}
    </div>
  );
};

export default React.memo(SelectorPopupSearch);
